import script from "./ElementToolbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementToolbar.vue?vue&type=script&lang=ts&setup=true"

import "./ElementToolbar.vue?vue&type=style&index=0&id=f3d1ac70&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3d1ac70"]])

export default __exports__